// extracted by mini-css-extract-plugin
module.exports = {"accounts":"lfNlW","label":"mO4Ly","icon":"lny0B","surface":"_5VgPm","select":"HM0P1","list":"Xp5kD","row":"_4Y6mD","actions":"mWXEI"};